import { CircularProgress } from '@mui/material';
import * as React from 'react';
import { FullWidthBox } from '../fullWidthBox/FullWidthBox';

export const Loader = () => {
  return (
    <FullWidthBox>
      <CircularProgress />
      <div>Loading data...</div>
    </FullWidthBox>
  );
};
